import { useEffect } from 'react'

import { ApartmentPopup } from '@/components/ApartmentPopup'
import { Header } from '@/components/Header'
import { LoadingOverlay } from '@/components/LoadingOverlay'
import { MobileBar } from '@/components/MobileBar'
import { ProjectInfoModal } from '@/components/ProjectInfoModal'
import { PlacementPanel } from '@/components/PlacementPanel'
import { RegisterCta } from '@/components/RegisterCta'
import { RegisterModal } from '@/components/RegisterModal'
import { SceneDock } from '@/components/SceneDock'
import { ToolPanels } from '@/components/ToolPanels'
import { WalkHud } from '@/components/WalkHud'
import { useAppStore } from '@/store'
import { initViewer } from '@/three/viewer'

export function App() {
  const setViewer = useAppStore((s) => s.setViewer)
  const setProgress = useAppStore((s) => s.setProgress)
  const setLoaded = useAppStore((s) => s.setLoaded)
  const walkEnded = useAppStore((s) => s.walkEnded)
  const setTheme = useAppStore((s) => s.setTheme)
  const theme = useAppStore((s) => s.theme)

  useEffect(() => {
    setTheme(theme)
    // The token flip is applied once on mount; the toggle drives it after that.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const viewer = initViewer({
      onProgress: setProgress,
      onLoaded: () => setLoaded(true),
      onWalkEnded: walkEnded,
    })
    setViewer(viewer)
    return () => {
      viewer.dispose()
      setViewer(null)
    }
  }, [setViewer, setProgress, setLoaded, walkEnded])

  return (
    <>
      {/* The viewer owns everything inside these two: the WebGL canvas, and the
          hotspot labels it projects from 3D each frame. React renders the
          containers and the chrome around them. */}
      <div id="threejs-container" className="fixed inset-0" />
      <div id="hotspot-container" className="pointer-events-none fixed inset-0 z-10" />

      <Header />
      <SceneDock />
      <MobileBar />
      <ToolPanels />
      <RegisterCta />
      <ProjectInfoModal />
      <RegisterModal />
      <ApartmentPopup />
      <WalkHud />
      {/* Authoring surface, never part of the visitor build path. */}
      {new URLSearchParams(location.search).has('layout') && <PlacementPanel />}
      <LoadingOverlay />
    </>
  )
}
